import { pickedApiRequest } from './request'

export default {
  /**
   * Public list of verified pilot hiring templates. Only templates whose
   * every test exists in the library are returned by the server.
   *
   * @return {Object} { templates, nextAction, maxExams, verifiedAt }
   */
  index () {
    return pickedApiRequest.get('assessment/pilot-templates')
      .then(response => {
        return response.data.data
      })
  }
}
